<template>
  <v-container-with-title
    title="Clasificaciones"
    subtitle="Indicando cuántos items están clasificados y cuántos están sin clasificar pero con predicciones para esa clase"
  >
    <v-layout>
      <v-flex>
        <v-classifications-table />
      </v-flex>
    </v-layout>
  </v-container-with-title>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("classifier");

import VClassificationsTable from "./Table";
import VContainerWithTitle from "@/components/containers/ContainerWithTitle";

export default {
  components: {
    VClassificationsTable,
    VContainerWithTitle
  },
  /**
   * Remove the current classification when loading this view to not have
   * any selected classification.
   */
  created() {
    this.setCurrentClassification();
  },
  methods: {
    ...mapActions(["setCurrentClassification"])
  }
};
</script>